import { Table } from "semantic-ui-react";
import React from "react";
import { EmployeeTableRow } from "./EmployeeTableRow";
import "../../utils/stylesheet.css";

export const EmployeeTable = ({ employees, reload }) => {
  let rows = employees.map((employee) => (
    <EmployeeTableRow key={employee.id} employee={employee} reload={reload} />
  ));

  return (
    <Table selectable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Nome</Table.HeaderCell>
          <Table.HeaderCell>Gestor</Table.HeaderCell>
          <Table.HeaderCell>Cargo</Table.HeaderCell>
          <Table.HeaderCell>Área</Table.HeaderCell>
          <Table.HeaderCell>Ações</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};
